/**
 * Utilitários do domínio do prontuário (PEV).
 * Mantidos fora do mixin global para não ampliar a superfície compartilhada do app.
 */

/**
 * Converte um timestamp em milissegundos para o formato aceito por <input type="date">.
 * @param {number|null|undefined} ts
 * @returns {string} "YYYY-MM-DD" ou "" quando não houver timestamp.
 */
export function timestampToDateInput(ts) {
  if (!ts) return "";
  const d = new Date(ts);
  const year = d.getFullYear();
  const month = String(d.getMonth() + 1).padStart(2, "0");
  const day = String(d.getDate()).padStart(2, "0");
  return `${year}-${month}-${day}`;
}

/**
 * Converte o valor de um <input type="date"> em timestamp ao meio-dia local,
 * evitando que o fuso horário mova a data para o dia anterior.
 * @param {string} value "YYYY-MM-DD"
 * @returns {number|null}
 */
export function dateInputToTimestamp(value) {
  if (!value) return null;
  const [year, month, day] = value.split("-").map(Number);
  if (!year || !month || !day) return null;
  return new Date(year, month - 1, day, 12, 0, 0).getTime();
}

/**
 * Converte o valor de um <input type="date"> em timestamp de data clínica.
 * O backend recusa (HTTP 400) data futura com tolerância de 5 minutos, e o
 * meio-dia local usado por `dateInputToTimestamp` deixa a data de hoje no
 * futuro durante toda a manhã. Por isso o valor é limitado ao instante atual.
 * @param {string} value "YYYY-MM-DD"
 * @returns {number|undefined}
 */
export function dateInputToClinicalTimestamp(value) {
  const timestamp = dateInputToTimestamp(value);
  if (!timestamp) return undefined;
  return Math.min(timestamp, Date.now());
}

export default {
  timestampToDateInput,
  dateInputToTimestamp,
  dateInputToClinicalTimestamp
};
